"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _green = _interopRequireDefault(require("../tokens/color/green"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _DownTriangle = _interopRequireDefault(require("../Icons/all/DownTriangle"));
var _commonHelper = require("../helpers/commonHelper");
var _OnClickOutside = _interopRequireDefault(require("../HOC/OnClickOutside"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// import { grey, white, green, red } from "../tokens/color";

var getLeftSectionMargin = function getLeftSectionMargin(_ref) {
  var isCompact = _ref.isCompact,
    isCentered = _ref.isCentered,
    isSpaced = _ref.isSpaced;
  if (isCentered) {
    return "0 2rem";
  }
  if (isSpaced) {
    return "0 1rem";
  }
  return "0 ".concat(isCompact ? 0.5 : 2, "rem 0 0");
};
var Dropdown = function Dropdown(props) {
  var value = props.value,
    width = props.width,
    rightIcon = props.rightIcon,
    onSelect = props.onSelect,
    children = props.children,
    _props$leftIcon = props.leftIcon,
    leftIcon = _props$leftIcon === void 0 ? null : _props$leftIcon,
    _props$leftNode = props.leftNode,
    leftNode = _props$leftNode === void 0 ? null : _props$leftNode,
    _props$helperText = props.helperText,
    helperText = _props$helperText === void 0 ? "" : _props$helperText,
    _props$errorText = props.errorText,
    errorText = _props$errorText === void 0 ? "" : _props$errorText,
    _props$showArrow = props.showArrow,
    showArrow = _props$showArrow === void 0 ? false : _props$showArrow,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$isCompact = props.isCompact,
    isCompact = _props$isCompact === void 0 ? false : _props$isCompact,
    _props$isSpaced = props.isSpaced,
    isSpaced = _props$isSpaced === void 0 ? false : _props$isSpaced,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? "" : _props$borderColor,
    isNaked = props.isNaked,
    isTransparent = props.isTransparent,
    staticHeader = props.staticHeader,
    maxMenuHeight = props.maxMenuHeight,
    isCentered = props.isCentered,
    placeholder = props.placeholder,
    shouldChange = props.shouldChange,
    _props$noMarginTop = props.noMarginTop,
    noMarginTop = _props$noMarginTop === void 0 ? false : _props$noMarginTop,
    _props$heading = props.heading,
    heading = _props$heading === void 0 ? "" : _props$heading,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? "" : _props$fontSize,
    _props$fontWeight = props.fontWeight,
    fontWeight = _props$fontWeight === void 0 ? "" : _props$fontWeight,
    _props$color = props.color,
    color = _props$color === void 0 ? "" : _props$color,
    _props$borderRadius = props.borderRadius,
    borderRadius = _props$borderRadius === void 0 ? "" : _props$borderRadius,
    _props$customPadding = props.customPadding,
    customPadding = _props$customPadding === void 0 ? "" : _props$customPadding,
    _props$enableClick = props.enableClick,
    enableClick = _props$enableClick === void 0 ? false : _props$enableClick;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isMenuOpen = _useState2[0],
    toggleMenu = _useState2[1];
  var _useState3 = (0, _react.useState)(value),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    label = _useState4[0],
    setLabel = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedChild = _useState6[0],
    setSelectedChild = _useState6[1];
  var toggle = function toggle() {
    return toggleMenu(!isMenuOpen);
  };
  var openMenu = function openMenu() {
    return toggleMenu(true);
  };
  var closeMenu = function closeMenu() {
    !enableClick && toggleMenu(false);
    setSelectedChild(0);
  };
  var changeOnSelect = function changeOnSelect(val, label) {
    setLabel(label);
    onSelect(val);
    setSelectedChild(0);
  };
  var handleOnSelect = function handleOnSelect(val, label) {
    if (typeof shouldChange === "function") {
      if (shouldChange(val)) {
        changeOnSelect(val, label);
      }
    } else {
      changeOnSelect(val, label);
    }
    closeMenu();
  };
  (0, _react.useEffect)(function () {
    setLabel(value);
  }, [value]);
  var randomId = "id-" + (Math.random() * 10).toFixed(3);
  var showText = errorText ? errorText : helperText ? helperText : "";
  var isError = !!errorText;
  var handleItemSelect = function handleItemSelect(e, key) {
    e.preventDefault();
    if (children && children.length) {
      var handleUpKeyPress = function handleUpKeyPress() {
        if (!selectedChild) {
          setSelectedChild(1);
        } else {
          if (selectedChild !== 1) setSelectedChild(selectedChild - 1);
        }
      };
      var handleDownKeyPress = function handleDownKeyPress() {
        if (!selectedChild) setSelectedChild(1);
        if (selectedChild !== children.length) setSelectedChild(selectedChild + 1);
      };
      var handleEnterKeyPress = function handleEnterKeyPress() {
        if (selectedChild) {
          var selected = childValueLabelMapping[selectedChild] || {};
          var _selected$value = selected.value,
            _value = _selected$value === void 0 ? "" : _selected$value,
            _selected$label = selected.label,
            _label = _selected$label === void 0 ? "" : _selected$label;
          handleOnSelect(_value, _label);
        }
      };
      switch (key) {
        case "UP":
          handleUpKeyPress();
          break;
        case "DOWN":
          handleDownKeyPress();
          break;
        case "ENTER":
          handleEnterKeyPress();
          break;
      }
    }
  };
  var childValueLabelMapping = {};
  var renderModifiedChildren = function renderModifiedChildren(children) {
    var modifiedChildren = _react["default"].Children.map(children, function (ch, i) {
      var keySelected = selectedChild === i + 1;
      childValueLabelMapping[i + 1] = {
        value: ch.props.value,
        label: ch.props.label
      };
      return (0, _commonHelper.cloneChildren)(ch, {
        _passClick: handleOnSelect,
        id: randomId,
        keySelected: keySelected
      });
    });
    return modifiedChildren;
    // return children.map((ch, i) => {
    //   const keySelected = selectedChild === i + 1;
    //   childValueLabelMapping[i + 1] = {
    //     value: ch.props.value,
    //     label: ch.props.label
    //   };
    //   return cloneChildren(ch, {
    //     _passClick: handleOnSelect,
    //     id: randomId,
    //     keySelected
    //   });
    // });
  };
  var getLeftSectionText = function getLeftSectionText() {
    if (staticHeader) {
      return (0, _commonHelper.cloneChildren)(staticHeader);
    }
    if (label) {
      return label;
    }
    return placeholder;
  };
  return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
    handleClickOutside: closeMenu,
    width: width,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(DropdownWrapper, {
    width: width,
    "aria-describedby": "dropdown-help-".concat(randomId),
    "aria-activedescendant": randomId + "-selected",
    onFocus: openMenu,
    onBlur: closeMenu,
    onKeyDown: (0, _commonHelper.onKeyChoose)(handleItemSelect),
    tabIndex: "0"
  }, /*#__PURE__*/_react["default"].createElement(HeaderWrapper, {
    isMenuOpen: isMenuOpen,
    isError: isError,
    onMouseDown: toggle,
    isCompact: isCompact,
    borderColor: borderColor,
    isNaked: isNaked,
    isTransparent: isTransparent,
    heading: heading,
    borderRadius: borderRadius,
    customPadding: customPadding,
    isSpaced: isSpaced
  }, /*#__PURE__*/_react["default"].createElement(LeftSection, {
    isCompact: isCompact,
    isTransparent: isTransparent,
    isCentered: isCentered,
    isSpaced: isSpaced
  }, heading && /*#__PURE__*/_react["default"].createElement(Heading, null, heading), /*#__PURE__*/_react["default"].createElement(LeftSectionContent, {
    isCentered: isCentered
  }, !!leftIcon && (0, _commonHelper.cloneChildren)(leftIcon, {
    size: heading ? 13 : 16,
    color: isTransparent ? _white["default"] : _grey["default"].z800
  }), !!leftNode && !leftIcon && (0, _commonHelper.cloneChildren)(leftNode), /*#__PURE__*/_react["default"].createElement(Span, {
    hasLeftIcon: !!leftIcon || !!leftNode,
    isTransparent: isTransparent,
    hasNoMargin: isNaked || noMarginTop,
    isPlaceholder: !label,
    heading: heading,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color
  }, getLeftSectionText()))), /*#__PURE__*/_react["default"].createElement(RightSection, {
    isMenuOpen: isMenuOpen
  }, (0, _commonHelper.cloneChildren)(rightIcon, {
    size: 14,
    color: isTransparent ? _white["default"] : _grey["default"].z400
  }))), !!showText && /*#__PURE__*/_react["default"].createElement(HelperText, {
    isError: isError,
    id: "dropdown-help-".concat(randomId)
  }, showText), /*#__PURE__*/_react["default"].createElement(MenuHolder, {
    showArrow: showArrow,
    isOpen: isMenuOpen,
    heading: heading,
    isSpaced: isSpaced,
    borderRadius: borderRadius
  }, isMenuOpen && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showArrow && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MenuHolder.Arrow, null), /*#__PURE__*/_react["default"].createElement(Cover, null)), /*#__PURE__*/_react["default"].createElement(MenuWrapper, {
    maxMenuHeight: maxMenuHeight
  }, renderModifiedChildren(children))))));
};
var getCommonTop = function getCommonTop(showArrow, isSpaced) {
  if (isSpaced) {
    return "4rem";
  }
  if (showArrow) {
    return "5.8rem";
  }
  return "5.3rem";
};
var getTop = function getTop(_ref2, isMobile) {
  var showArrow = _ref2.showArrow,
    heading = _ref2.heading,
    isSpaced = _ref2.isSpaced;
  if (showArrow && heading) {
    return isMobile ? "5.7rem" : "6.5rem";
  }
  if (heading) {
    return isMobile ? "5.2rem" : "6rem";
  }
  return getCommonTop(showArrow, isSpaced);
};
var MenuHolder = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-qnejpk-0"
})(["position:absolute;top:", ";width:100%;border-radius:", ";background:", ";box-shadow:0px 1px 8px rgba(28,28,28,0.15);z-index:10;opacity:", ";transition:opacity,transform ", " ease;transform:translateY(", ");@media (max-width:480px){top:", ";}"], function (props) {
  return getTop(props);
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius ? borderRadius : _misc["default"].radius;
}, _white["default"], function (props) {
  return props.isOpen ? "1" : "0";
}, _misc["default"].animationDuration, function (props) {
  return props.isOpen ? "0" : "-1rem";
}, function (props) {
  return getTop(props, true);
});
var MenuWrapper = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-qnejpk-1"
})(["margin:1rem 0;max-height:", ";overflow-y:auto;::-webkit-scrollbar{display:none;}"], function (props) {
  return props.maxMenuHeight;
});
var Cover = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-qnejpk-2"
})(["position:absolute;right:1.5rem;width:2.5rem;height:1rem;top:0;background:white;"]);
MenuHolder.Arrow = _styledComponents["default"].div.withConfig({
  componentId: "sc-qnejpk-3"
})(["position:absolute;width:1.4rem;height:1.4rem;transform:rotate(45deg);top:-7px;right:2rem;background:white;box-shadow:0px -1px 3px rgba(28,28,28,0.15);"]);
var RightSection = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-qnejpk-4"
})(["transform:", ";transition:transform ", ";"], function (props) {
  return props.isMenuOpen ? "rotate(180deg)" : "none";
}, _misc["default"].animationDuration);
var HelperText = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  componentId: "sc-qnejpk-5"
})(["font-size:11px;margin:2px 0;color:", ";"], function (props) {
  return props.isError ? _red["default"].z400 : _grey["default"].z400;
});
Dropdown.propTypes = {
  value: _propTypes["default"].string,
  width: _propTypes["default"].string,
  leftIcon: _propTypes["default"].node,
  leftNode: _propTypes["default"].node,
  rightIcon: _propTypes["default"].node,
  children: _propTypes["default"].node,
  onSelect: _propTypes["default"].func.isRequired,
  helperText: _propTypes["default"].string,
  errorText: _propTypes["default"].string,
  showArrow: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  isCompact: _propTypes["default"].bool,
  isSpaced: _propTypes["default"].bool,
  borderColor: _propTypes["default"].string,
  isNaked: _propTypes["default"].bool,
  isTransparent: _propTypes["default"].bool,
  staticHeader: _propTypes["default"].node,
  maxMenuHeight: _propTypes["default"].string,
  isCentered: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  shouldChange: _propTypes["default"].func,
  noMarginTop: _propTypes["default"].bool,
  heading: _propTypes["default"].string,
  fontSize: _propTypes["default"].string,
  fontWeight: _propTypes["default"].string,
  color: _propTypes["default"].string,
  borderRadius: _propTypes["default"].string,
  customPadding: _propTypes["default"].string,
  enableClick: _propTypes["default"].bool
};
Dropdown.defaultProps = {
  label: "Choose...",
  value: "",
  width: "",
  leftIcon: null,
  leftNode: null,
  rightIcon: /*#__PURE__*/_react["default"].createElement(_DownTriangle["default"], null),
  children: null,
  showArrow: false,
  isNaked: false,
  isTransparent: false,
  staticHeader: null,
  maxMenuHeight: "30rem",
  isCentered: false,
  isSpaced: false,
  placeholder: "",
  noMarginTop: false,
  heading: "",
  fontSize: "",
  fontWeight: "",
  color: "",
  borderRadius: "",
  customPadding: "",
  enableClick: false
};
var getFontSize = function getFontSize(_ref4) {
  var heading = _ref4.heading,
    fontSize = _ref4.fontSize;
  var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (fontSize) {
    return fontSize;
  }
  if (isMobile) {
    return heading ? "1.4rem" : "1.8rem";
  }
  return heading ? "1.6rem" : "1.8rem";
};
var getFontWeight = function getFontWeight(_ref5) {
  var fontWeight = _ref5.fontWeight;
  return fontWeight ? fontWeight : "300";
};
var Span = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-qnejpk-6"
})(["margin-left:", ";margin-top:", ";color:", ";font-size:", ";font-weight:", ";overflow:hidden;text-overflow:ellipsis;@media (max-width:480px){font-size:", ";}"], function (props) {
  return props.hasLeftIcon ? "1rem" : "0";
}, function (props) {
  return props.hasNoMargin ? 0 : "0.2rem";
}, function (props) {
  return getTextColor(props);
}, function (props) {
  return getFontSize(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return getFontSize(props, true);
});
var getJustifyContent = function getJustifyContent(props) {
  if (props.isSpaced) {
    return "flex-start";
  } else if (props.isNaked) {
    return "flex-end";
  } else {
    return "space-between";
  }
};
var LeftSection = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-qnejpk-7"
})(["margin:", ";width:", ";"], function (props) {
  return getLeftSectionMargin(props);
}, function (_ref6) {
  var isCentered = _ref6.isCentered;
  return isCentered ? "100%" : "inherit";
});
var LeftSectionContent = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-qnejpk-8"
})(["display:flex;align-items:center;overflow:hidden;white-space:nowrap;justify-content:", ";"], function (_ref7) {
  var isCentered = _ref7.isCentered;
  return isCentered ? "center" : "unset";
});
var HeaderWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-qnejpk-9"
})(["display:flex;align-items:center;justify-content:", ";padding:", ";font-size:18px;height:", "rem;border:", ";border-radius:", ";cursor:pointer;background:", ";@media (max-width:480px){height:", "rem;}"], function (props) {
  return getJustifyContent(props);
}, function (props) {
  return getPadding(props);
}, function (_ref8) {
  var heading = _ref8.heading;
  return heading ? 6 : 4.8;
}, function (props) {
  return getBorder(props);
}, function (_ref9) {
  var borderRadius = _ref9.borderRadius;
  return borderRadius ? borderRadius : _misc["default"].radius;
}, function (props) {
  return getBGColor(props);
}, function (_ref10) {
  var heading = _ref10.heading;
  return heading ? 5.2 : 4.8;
});
var Heading = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-qnejpk-10"
})(["font-size:1.4rem;color:", ";line-height:1.8rem;@media (max-width:480px){font-size:1.2rem;}"], _grey["default"].z500);
var getBGColor = function getBGColor(props) {
  return props.isError ? _red["default"].z100 : props.isTransparent ? "transparent" : "#fff";
};
var getPadding = function getPadding(props) {
  if (props.isError) {
    return props.isCompact ? "1.5rem 1rem" : "1.5rem 1.85rem";
  } else {
    if (props.isNaked) {
      return "1rem 0";
    } else if (props.customPadding) {
      return props.customPadding;
    } else if (props.isMenuOpen) {
      return props.isCompact ? "1.5rem 1.05rem" : "1.5rem 1.9rem";
    } else {
      return props.isCompact ? "1.65rem 1.15rem" : "1.65rem 2rem";
    }
  }
};
var getBorder = function getBorder(props) {
  return function () {
    if (props.isNaked) {
      return "none";
    } else if (props.isError) {
      return "2px solid ".concat(_red["default"].z600);
    } else {
      if (props.isMenuOpen) {
        return "2px solid ".concat(props.borderColor ? props.borderColor : _green["default"].z500);
      } else {
        return "1px solid " + _grey["default"].z300;
      }
    }
  };
};
var getTextColor = function getTextColor(props) {
  if (props.color) {
    return props.color;
  }
  if (props.isTransparent) {
    return _white["default"];
  }
  if (props.isPlaceholder) {
    return _grey["default"].z300;
  }
  return _grey["default"].z800;
};
var DropdownWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-qnejpk-11"
})(["position:relative;width:", ";"], function (props) {
  return props.width ? props.width : _misc["default"].dropdown.defaultWidth;
});
var _default = exports["default"] = Dropdown;